/*
 * @Descripttion:
 * @Author: yang chenglin
 * @Date: 2021-01-14 10:19:15
 * @LastEditors: yang chenglin
 * @LastEditTime: 2021-05-13 17:34:36
 */
// Dialog组件封装
// TODO: 还没有根据提供的UI完成样式定制
import React from 'react';
import { Dialog } from '@alifd/next';

export default (props) => <Dialog {...props} />;
